import { IssuerStatus, PaymentMethod } from '@/Enums';
import type { Issuer } from './types';

/**
 * Creates an empty Issuer object with default values
 */
export function createEmptyIssuer(): Issuer {
  return {
    id: 0,
    companyName: '',
    contactEmployeeId: 0,
    contactEmployee: {
      id: 0,
      firstName: '',
      lastName: '',
      phoneNumber: '',
      email: ''
    },
    contactAddressId: 0,
    contactAddress: {
      id: 0,
      street: '',
      town: '',
      zipCode: ''
    },
    businessAddressId: 0,
    businessAddress: {
      id: 0,
      street: '',
      town: '',
      zipCode: ''
    },
    status: IssuerStatus.Interested,
    interestedNumber: 0,
    businessBankAccountId: 0,
    businessBankAccount: {
      id: 0,
      creditInstitute: '',
      iban: '',
      bic: '',
      accountOwnerName: ''
    },
    websiteLogoId: 0,
    websiteLogo: {
      id: 0,
      format: '',
      data: ''
    },
    paycardLogoId: 0,
    paycardLogo: {
      id: 0,
      format: '',
      data: ''
    },
    personalizedLogoId: 0,
    personalizedLogo: {
      id: 0,
      format: '',
      data: ''
    },
    paymentDetailsId: 0,
    paymentDetails: {
      paymentMethod: PaymentMethod.invoice,
      sepaDebitDate: undefined,
      mandateReference: undefined,
      invoiceEmail: undefined
    },
    isWebsitePartner: false,
    isMerchant: false,
    paycardCount: 0,
    personalizePaycard: false,
    contractStart: undefined,
    contractEnd: undefined,
    serviceEnd: undefined,
  };
}

/**
 * Checks if an issuer is new
 */
export function isNewIssuer(issuer: Issuer): boolean {
  return issuer.id === 0;
}
